import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import {
  ExpenseConcept,
  ExpenseConceptInsert,
  ExpenseConceptSearchCommand,
  ExpenseConceptUpdate,
} from '../models/expense-concept/expense-concept';
import { PagedResult } from './bank-account.proxy.service';

@Injectable({ providedIn: 'root' })
export class ExpenseConceptProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/expense-concept';

  public search(
    command: ExpenseConceptSearchCommand,
    pageNumber: number,
    pageSize: number,
    sortField: string | null,
    sortOrder: number,
  ): Observable<ApiResponse<PagedResult<ExpenseConcept>>> {
    let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize).set('sortOrder', sortOrder);
    if (sortField) params = params.set('sortField', sortField);
    return this.httpClient.post<ApiResponse<PagedResult<ExpenseConcept>>>(`${this.baseUrl}/search`, command, { params });
  }

  public getById(id: string): Observable<ApiResponse<ExpenseConcept>> {
    return this.httpClient.get<ApiResponse<ExpenseConcept>>(`${this.baseUrl}/${id}`);
  }

  /** The concepts for these codes; unknown codes are skipped. */
  public getByCodes(codes: string[]): Observable<ApiResponse<ExpenseConcept[]>> {
    return this.httpClient.post<ApiResponse<ExpenseConcept[]>>(`${this.baseUrl}/code/batch`, codes);
  }

  public create(payload: ExpenseConceptInsert): Observable<ApiResponse<ExpenseConcept>> {
    return this.httpClient.post<ApiResponse<ExpenseConcept>>(this.baseUrl, payload);
  }

  public update(id: string, payload: ExpenseConceptUpdate): Observable<ApiResponse<ExpenseConcept>> {
    return this.httpClient.put<ApiResponse<ExpenseConcept>>(`${this.baseUrl}/${id}`, payload);
  }
}
